<template>
    <component
        :is="getFiltersParams.filterLayout"
        :disabled-filters="myData.disabledFilters"
        :filters-config="getFiltersConfig"
        :searchTermValue="getFiltersParams.searchTermValue"
        :selectedPrimaryFilter="getFiltersParams.selectedPrimaryFilter"
        :filtersWrapperNode="myNode"
        :selectedSecondaryFilter="getFiltersParams.selectedSecondaryFilter"
        :showFilters= "getFiltersParams.showFilters"
        @primary-filter-applied="primaryFilterApplied"
        @secondary-filter-applied="secondaryFilterApplied"
    >

    </component>
</template>

<script>
    import PreviewComponent from "./PreviewComponent";
    import FiltersComponent from "../../components/pagesbuilder/dynamic-components/FiltersComponent";
    import CourseCardsFilters1 from "../../author/pagesbuilder/templates/cards/CourseCardsFilters1";
    import CourseCardsFilters2 from "../../author/pagesbuilder/templates/cards/CourseCardsFilters2";
    import CourseCardsFilters3 from "../../author/pagesbuilder/templates/cards/CourseCardsFilters3";
    import CourseCardsFilters4 from "../../author/pagesbuilder/templates/cards/CourseCardsFilters4";
    import CourseCardsFilters5 from "../../author/pagesbuilder/templates/cards/CourseCardsFilters5";
    import CourseCardsFilters6 from "../../author/pagesbuilder/templates/cards/CourseCardsFilters6";
    import BundleCardsFilters1 from "../../author/pagesbuilder/templates/cards/BundleCardsFilters1";
    import CourseCardsFiltersInSidebar from "../../author/pagesbuilder/templates/cards/CourseCardsFiltersInSidebar";

    export default {
        name: "PreviewFiltersComponent",
        mixins: [
            PreviewComponent,
            FiltersComponent,

        ],
        components : {
            CourseCardsFilters1,
            CourseCardsFilters2,
            CourseCardsFilters3,
            CourseCardsFilters4,
            CourseCardsFilters5,
            CourseCardsFilters6,
            CourseCardsFiltersInSidebar,
            BundleCardsFilters1,
        }
    }
</script>

